import useMutation from "src/hooks/useMutation";

function useBrandRemove(id) {
  return useMutation({
    path: `/api/v1/brands/${id}`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/brands`,
      shouldRevalidate: true,
    },
  });
}

export default useBrandRemove;
